import gql from 'graphql-tag';

const TRANSACTION_PUBLISHERS_BY_CAMPAIGN = gql`
  query transactionPublisherByCampaigns($adProviderId: String!) {
    transactionPublisherByCampaigns(where: { adProviderId: $adProviderId }) {
      id
      adProviderId
      impressions
      transactions
      byDate {
        date
        impressions
        transactions
      }
      publisher {
        name
        media
      }
    }
  }
`;

export default TRANSACTION_PUBLISHERS_BY_CAMPAIGN;
